import { useEffect, useState } from 'react';

// Hook: retorna `value` apos ele ter ficado estavel por `delayMs`.
// Util pra inputs de busca onde a gente nao quer disparar fetch a cada
// keystroke. O input em si permanece "controlled" (atualizando o state
// imediato pra o usuario ver o que digitou), mas o `debouncedValue`
// retornado so muda quando o usuario para de digitar.
//
// Uso:
//   const [search, setSearch] = useState('');
//   const debouncedSearch = useDebounce(search, 300);
//   useEffect(() => { fetch(debouncedSearch); }, [debouncedSearch]);
export const useDebounce = (value, delayMs = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
};

export default useDebounce;
